import { render } from "./SpecialistAdd.vue?vue&type=template&id=4ba381bc&scoped=true"
import script from "./SpecialistAdd.vue?vue&type=script&lang=js"
export * from "./SpecialistAdd.vue?vue&type=script&lang=js"

import "./SpecialistAdd.vue?vue&type=style&index=0&id=4ba381bc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ba381bc"]])

export default __exports__